module.exports = {
  ConfigureDisplayColumns: 'Cấu hình cột hiển thị',
  AllNames: 'Tất cả tên',
  SelectedColumns: 'Cột đã chọn',
  YouToViewSecondaryInformation: 'Bạn không có quyền xem thông tin bảng cấp hai!',
  Yes: 'Có',
  WorkflowNumber: 'Số công việc',
  YouToSetSecondaryColumns: 'Bạn không có quyền thiết lập cột hiển thị bảng cấp hai!',
  CancelCounting: 'Hủy đếm'
}
